function Modal({ children }) {
    return (
        <div className="absolute h-screen w-screen bg-black/70 z-[100] flex flex-col items-center justify-center gap-2 overflow-auto">
            { children }
        </div>
    )
}

export default Modal;